module.exports = __webpack_public_path__ + "static/img/banner.42a973e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/banner.jpg
// module id = gani
// module chunks = 1